import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  CrossOpinionEnum,
  CrossOpinionOptionKeysEnum,
} from '../../../../../types/contract/contract-product-cross-reference.enums';

@Component({
    selector: 'app-clinical-assessment-vote',
    templateUrl: './clinical-assessment-vote.component.html',
    styleUrls: ['./clinical-assessment-vote.component.scss'],
    standalone: false
})
export class ClinicalAssessmentVoteComponent implements OnInit {
  @Input() approveCount = 0;
  @Input() disputeCount = 0;
  @Input() crossOpinion = '';
  @Input() canUpdateOpinion = false;
  @Output() updateOpinion = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  toggleDownVoteClick() {
    const votedOpinionKey =
      this.crossOpinion === CrossOpinionEnum.DISPUTE
        ? CrossOpinionOptionKeysEnum.NO_OPINION
        : CrossOpinionOptionKeysEnum.UNACCEPTABLE;

    this.updateOpinion.emit({
      opinionOptionKey: votedOpinionKey,
    });
  }

  toggleUpVoteClick() {
    const votedOpinionKey =
      this.crossOpinion === CrossOpinionEnum.APPROVE
        ? CrossOpinionOptionKeysEnum.NO_OPINION
        : CrossOpinionOptionKeysEnum.CURRENT_PRODUCT;

    this.updateOpinion.emit({
      opinionOptionKey: votedOpinionKey,
    });
  }
}
